export const MISSING_SHIPPING_ADDRESS = `Une adresse de livraison est manquante`;
export const MISSING_SHIPPING_REF = `Une référence de préparation est manquante`;
